import React, { useEffect, useState } from 'react';
import logoAzFull from '../../utils/Img/logo_az_full.png';
import { getToday } from '../../utils/Date/SupportDate';

import './supportTools.css';

const style = {
    contentPrint: {
       textAlign:'center', 
       flex: 9, 
    }
  }

function ModalShowNotificationForm(props) {
    const { data, canManageTemplate, onSaveTemplate, categories = [] } = props;
    const [fontSize, setFontSize] = useState(25);
    const [dateSign, setDateSign] =useState({
        year :"",
        month: "",
        day:""
    });
    const [isPrint, setInPrint] = useState(false);
    const [isBorder, setIsBorder] = useState(true);
    const [lineContent, setLineContent] = useState([]);
    const [templateMeta, setTemplateMeta] = useState({
        _id: null,
        category: 'other',
        name: '',
        name2: '',
        name3: '',
        key: '',
    });
    const [saveLoading, setSaveLoading] = useState(false);
    const [saveNotice, setSaveNotice] = useState('');

    useEffect(()=> {
        const today = getToday();
        setDateSign({
            year : today.slice(0,4),
            month : today.slice(5,7),
            day: today.slice(8,10)
        });

        const incomingContent = Array.isArray(data?.content) ? data.content : [];
        const parsedContent = incomingContent.map((item) => ({
            text: item?.text || '',
            edit: Boolean(item?.edit),
        }));

        setLineContent(parsedContent);

        setTemplateMeta({
            _id: data?._id || null,
            category: data?.category || 'other',
            name: data?.name || '',
            name2: data?.name2 || '',
            name3: data?.name3 || '',
            key: data?.key || '',
        });
        setSaveNotice('');

        setIsBorder(true);
        setFontSize((data?.fontSize || 25) - 5);
    },[data]);

    useEffect(()=>{
            if(isPrint) {
                props.onPrint("printArea");
                setInPrint(false);
                setFontSize(fontSize-5);
            }
    },[isPrint, props, fontSize]);

    function onChangeDateSign(value,target) {
        const newData = {...dateSign};
        newData[target] = value;
        setDateSign(newData)
    }

    function changeLineText(index, text) {
        const newData = [...lineContent];
        newData[index] = {
            ...newData[index],
            text,
        };
        setLineContent(newData);
    }

    function changeLineEdit(index, value) {
        const newData = [...lineContent];
        newData[index] = {
            ...newData[index],
            edit: value,
        };
        setLineContent(newData);
    }

    function renderRow() {
        let result = [];

        lineContent.forEach((item, index) => {
            if(!isPrint) {
                return result.push(<textarea
                    className='no-print'
                    key = {index}
                    value = {item.text}
                    onChange = {e => changeLineText(index, e.target.value)}
                    style={{ 
                            fontSize: fontSize + 3, 
                            padding: '0', 
                            textAlign:'center', 
                            width: '100%',
                            color: item.edit ? 'red' : 'black',
                            border: '0.5 solid black',
                            height:'38px',
                        }}>
                    {item.text}
                </textarea>)
            }

            return result.push(<div key={index} style={{ 
                fontSize: fontSize, 
                padding: '6px 0px', 
                textAlign:'center' }}>{item.text}</div>)
        });

        return result;
    }

    function onSetupPrint() {
        setFontSize(fontSize + 5);
        setInPrint(true);
    }

    async function onSaveCurrentTemplate() {
        if (!canManageTemplate || !onSaveTemplate) return;
        if (templateMeta.name.trim() === '' || templateMeta.name2.trim() === '' || templateMeta.name3.trim() === '') {
            alert('Please input full template title (EN/JP/VI).');
            return;
        }

        setSaveLoading(true);
        try {
            const payload = {
                _id: templateMeta._id,
                category: templateMeta.category || 'other',
                name: templateMeta.name,
                name2: templateMeta.name2,
                name3: templateMeta.name3,
                key: templateMeta.key,
                fontSize: Number(fontSize) + 5,
                content: lineContent,
            };

            const isCreatingTemplate = !templateMeta._id;
            const isOk = await onSaveTemplate(payload);
            if (isOk) {
                setSaveNotice('Save template success.');
                setTimeout(() => {
                    setSaveNotice('');
                }, 5000);
            }
            if (isOk && isCreatingTemplate && props.onClose) {
                props.onClose();
            }
        } catch (error) {
            alert('Save template failed.');
        }
        setSaveLoading(false);
    }

    return (<div className='d-flex' style={{ flex:10, height:'600px'}} >
        <div 
            className="modal-nf"
            id="printArea"
            style={style.contentPrint}>
            <div style={{ border: isBorder ? "1px solid black" : "0.1px solid white", padding :'0px 12px', height:'100%'}}>
                <div style={{ textAlign:'center', alignItems:'center', margin:'auto', marginTop:'24px', marginBottom:'12px' }}>
                    <img src={logoAzFull} alt="logoAzFull" width={180} /> 
                </div>
                {/* <div className='modal-nf_title' 
                    style={{ fontSize: fontSize + 10, paddingBottom: '12px' , textAlign:'center', fontWeight:'600' }}>
                    {data.name2}</div> */}
              {isPrint ? <div style={{ 
                        fontSize: fontSize + 12, 
                        marginBottom: '24px' , 
                        textAlign:'center', 
                        fontWeight:'600', 
                        padding: 0,
                        width:'100%',
                        height: '40px'
                    }}>{templateMeta.name2}</div> 
                    : <textarea 
                        value={templateMeta.name2}
                        onChange = {e => {
                            setTemplateMeta({
                                ...templateMeta,
                                name2: e.target.value,
                            });
                        }}
                      style={{
                        fontSize: fontSize + 10, 
                        textAlign:'center', 
                        fontWeight:'600', 
                        padding: 0,
                        width:'100%',
                        height: '40px'
                    }}/> }  
                {renderRow()}
                <div style={{ fontSize: fontSize, padding: '6px 0px', textAlign:'right' }}>{`${dateSign.year}年${Number(dateSign.month)}月${Number(dateSign.day)}日`}</div>
                <div style={{ fontSize: fontSize, padding: '6px 0px', textAlign:'right' }}>東屋ホテル マネージャー</div>
            </div>
        </div>
        <div style={{flex: 1.5}} className='mt-5 ml-2'>
            <div style={{ border:'1px solid black' }}>
                <span>Change font size:</span>
                <input value={fontSize} type="number" onChange={e => setFontSize(Number(e.target.value))}
                    style={{width:'80px'}}></input>
                <div className='d-flex mt-1' style={{textAlign:'center', alignItems:'center', margin:'auto'}}>
                    <button className='btn btn-success'
                         onClick={()=>setFontSize(fontSize+1)}>+</button>
                    <button className='btn btn-danger'
                         onClick={()=>setFontSize(fontSize-1)}>-</button>
                </div>
            </div>

            <div style={{ border:'1px solid black' }} className='mt-2'>
                <span>Change Date Notification:</span>
                <div className='d-flex'>
                    <div style={{width:'70px', minWidth:'70px', maxWidth:'70px', textAlign:'right', marginRight:'4px'}}>Year:</div> 
                    <input value={dateSign.year} type="number" onChange={e => onChangeDateSign(e.target.value, "year")}
                        min="2022" max="2030"
                        style={{width:'50px'}}></input>
                </div>
                <div className='d-flex'>
                    <div style={{width:'70px', minWidth:'70px', maxWidth:'70px', textAlign:'right', marginRight:'4px'}}> Month:</div> 
                    <input value={dateSign.month} type="number" onChange={e => onChangeDateSign(e.target.value, "month")}
                         min="1" max="12"
                         style={{width:'50px'}}></input>
                </div>
                <div className='d-flex'>
                    <div style={{width:'70px', minWidth:'70px', maxWidth:'70px', textAlign:'right', marginRight:'4px'}}>Day:</div> 
                    <input value={dateSign.day} type="number" onChange={e => onChangeDateSign(e.target.value, "day")}
                         min="1" max="31"
                         style={{width:'50px'}}></input>
                </div>
            </div>
            
            <div className=''>
                    <label style={{textAlign:'right', marginRight:'4px', marginTop:'8px'}}>
                        * With border?
                        <input  type="checkbox" 
                                className='ml-1'
                                checked={isBorder}
                                onChange={() => setIsBorder(!isBorder)}
                            ></input>
                    </label> 
                </div>

            {canManageTemplate && (
                <div style={{ border:'1px solid black' }} className='mt-2 p-1'>
                    <div style={{fontWeight: 600}}>Template setting</div>
                    <div className='d-flex mt-1'>
                        <div style={{width:'90px'}}>Category:</div>
                        <select
                            value={templateMeta.category}
                            onChange={(e) => setTemplateMeta({ ...templateMeta, category: e.target.value })}
                            style={{ width: '140px' }}
                        >
                            {[...new Set([...(categories || []), templateMeta.category || 'other'])].map(item => (
                                <option value={item} key={item}>{item}</option>
                            ))}
                        </select>
                    </div>
                    <div className='d-flex mt-1'>
                        <div style={{width:'90px'}}>Name EN:</div>
                        <input value={templateMeta.name} onChange={(e) => setTemplateMeta({ ...templateMeta, name: e.target.value })} />
                    </div>
                    <div className='d-flex mt-1'>
                        <div style={{width:'90px'}}>Name JP:</div>
                        <input value={templateMeta.name2} onChange={(e) => setTemplateMeta({ ...templateMeta, name2: e.target.value })} />
                    </div>
                    <div className='d-flex mt-1'>
                        <div style={{width:'90px'}}>Name VI:</div>
                        <input value={templateMeta.name3} onChange={(e) => setTemplateMeta({ ...templateMeta, name3: e.target.value })} />
                    </div>
                    <div className='d-flex mt-1'>
                        <div style={{width:'90px'}}>Tag key:</div>
                        <input value={templateMeta.key} onChange={(e) => setTemplateMeta({ ...templateMeta, key: e.target.value })} />
                    </div>
                    <div className='mt-1'>
                        <div style={{fontWeight: 600}}>Editable line setup</div>
                        {lineContent.map((line, index) => (
                            <label key={index} style={{display: 'block', marginBottom: 0}}>
                                <input
                                    type="checkbox"
                                    checked={Boolean(line.edit)}
                                    onChange={(e) => changeLineEdit(index, e.target.checked)}
                                />
                                <span className='ml-1'>Line {index + 1}</span>
                            </label>
                        ))}
                    </div>
                </div>
            )}

            <button className="btn btn-primary mt-2" onClick={()=>onSetupPrint()}>PRINT ANNOUNCEMENT</button>
            {canManageTemplate && (
                <button
                    className="btn btn-success mt-2 ml-2"
                    onClick={onSaveCurrentTemplate}
                    disabled={saveLoading}
                >
                    {saveLoading ? 'SAVING...' : (templateMeta._id ? 'UPDATE TEMPLATE' : 'SAVE TEMPLATE')}
                </button>
            )}
            {saveNotice && (
                <div className='mt-2' style={{
                    background: '#d1fae5',
                    color: '#065f46',
                    border: '1px solid #6ee7b7',
                    borderRadius: '6px',
                    padding: '6px 10px',
                    fontSize: '12px',
                    fontWeight: 600,
                }}>
                    {saveNotice}
                </div>
            )}
        </div>
    </div>)
}

export default ModalShowNotificationForm;
